import React from 'react';
import { Box, TextField, IconButton, InputAdornment } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import clsx from 'clsx';

import '../styles/ChatInput.css';

interface MessageInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSend: () => void;
  disabled?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const ChatInput: React.FC<MessageInputProps> = ({
  value,
  onChange,
  onSend,
  disabled = false,
  inputRef,
}) => {
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (value.trim() && !disabled) {
        onSend();
      }
    }
  };

  const isSendDisabled = disabled || !value.trim();

  return (
    <Box component="div" className="chat-input-container">
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="Message"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyPress}
        disabled={disabled}
        multiline
        maxRows={5}
        inputRef={inputRef}
        className="chat-textfield"
        InputProps={{
          inputProps: {
            className: 'chat-textfield-input',
          },
          className: 'chat-textfield-wrapper',
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Send message"
                onClick={onSend}
                disabled={isSendDisabled}
                className={clsx(
                  'send-button',
                  isSendDisabled ? 'send-button-disabled' : 'send-button-active'
                )}
                edge="end"
              >
                <SendIcon className="send-icon" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default ChatInput;
